// extracted by mini-css-extract-plugin
module.exports = {"day":"_28cYy0q7E_eP","dayOfWeekName":"_38YAcD8Vx8VH"};